module.exports = __webpack_public_path__ + "img/icon-lots.7d036a5d.svg";